<style lang="scss" scoped></style>
<template>
    <div>
        <Breadcrumb class="tablelist-header">
            <BreadcrumbItem>{{
                $t("erp.b2c.add_gift_list", { defaultValue: "添加礼品单" })
            }}</BreadcrumbItem>
        </Breadcrumb>
        <!-- 父订单信息 -->
        <div class="bg-fff shadow padding-bottom-20 margin-top-20">
            <header class="detail-title font-bold">
                {{
                    $t("erp.b2c.parent_order_information", {
                        defaultValue: "父订单信息",
                    })
                }}
            </header>
            <Form
                :label-width="120"
                :model="formData"
                ref="form"
                class="margin-15 clearfix"
            >
                <Col span="24">
                    <Col span="12">
                        <FormItem
                            :label="
                                $t('erp.b2c.parent_order_number', {
                                    defaultValue: '父订单号',
                                })
                            "
                            style="width: 333px"
                            class="pull-left"
                            prop="orderId"
                            :rules="required1"
                        >
                            <Input v-model="formData.orderId" readonly></Input>
                        </FormItem>
                        <!-- <Button class="pull-left margin-left-10" @click="getDetail(formData.orderId)">查询</Button> -->
                        <Button
                            class="pull-left margin-left-10"
                            @click="showFuorderBox"
                            >{{
                                $t("erp.b2c.query", {
                                    defaultValue: "查询",
                                })
                            }}</Button
                        >
                    </Col>
                    <Col span="12">
                        <FormItem
                            :label="
                                $t('erp.b2c.is_parent_order', {
                                    defaultValue: '是否回传父订单',
                                })
                            "
                            prop="comeback"
                            :rules="required"
                        >
                            <RadioGroup v-model="formData.comeback">
                                <Radio label="allow">
                                    <Icon type="social-yes"></Icon>
                                    <span>{{
                                        $t("boss.purchase.correct", {
                                            defaultValue: "是",
                                        })
                                    }}</span>
                                </Radio>
                                <Radio label="unAllow">
                                    <Icon type="social-no"></Icon>
                                    <span>{{
                                        $t("boss.purchase.deny", {
                                            defaultValue: "否",
                                        })
                                    }}</span>
                                </Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Col>
            </Form>
        </div>
        <!-- 收货信息 -->
        <div class="bg-fff shadow padding-bottom-20 margin-top-20">
            <header class="detail-title font-bold">
                {{
                    $t("boss.purchase.receipt_information", {
                        defaultValue: "收货信息",
                    })
                }}
            </header>
            <Form
                :label-width="120"
                :model="formData"
                ref="form2"
                class="margin-15 clearfix"
            >
                <Col span="24">
                    <Col span="12">
                        <FormItem
                            :label="
                                $t('erp.b2c.recipient', {
                                    defaultValue: '收件人',
                                })
                            "
                            style="width: 400px"
                            prop="shippingName"
                            :rules="required"
                        >
                            <Input v-model="formData.shippingName"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem
                            :label="
                                $t('erp.b2c.country_code', {
                                    defaultValue: '国家编码',
                                })
                            "
                            style="width: 400px"
                            prop="countryCode"
                            :rules="required"
                        >
                            <Select
                                v-model="formData.countryCode"
                                filterable
                                clearable
                                @on-change="
                                    oneCountry(formData.countryCode, 'edit')
                                "
                            >
                                <Option
                                    v-for="item in countries"
                                    :value="item.code ? item.code : item.nameEn"
                                    :key="item.id"
                                    >{{ item.code }} ({{ item.nameEn }})</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem
                            :label="
                                $t('erp.b2c.address_1', {
                                    defaultValue: '地址1',
                                })
                            "
                            style="width: 400px"
                            prop="addressline"
                            :rules="required"
                        >
                            <Input v-model="formData.addressline"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem
                            :label="
                                $t('erp.b2c.state_province', {
                                    defaultValue: '州/省份',
                                })
                            "
                            style="width: 400px"
                        >
                            <Select
                                v-model="formData.state"
                                filterable
                                clearable
                                ref="selectstate"
                            >
                                <Option
                                    v-for="item in states"
                                    :value="item.code ? item.code : item.nameEn"
                                    :key="item.id"
                                    >{{ item.code }} ({{ item.nameEn }})</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem
                            :label="
                                $t('erp.b2c.address_2', {
                                    defaultValue: '地址2',
                                })
                            "
                            style="width: 400px"
                        >
                            <Input v-model="formData.addressline2"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem
                            :label="
                                $t('erp.b2c.zip_code', {
                                    defaultValue: '邮编',
                                })
                            "
                            style="width: 400px"
                            prop="postalCode"
                            :rules="required"
                        >
                            <Input v-model="formData.postalCode"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="地址3" style="width: 400px">
                            <Input v-model="formData.addressline3"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem
                            :label="
                                $t('erp.b2c.phone', {
                                    defaultValue: '电话',
                                })
                            "
                            style="width: 400px"
                            prop="phone"
                            :rules="required"
                        >
                            <Input v-model="formData.phone"></Input>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem
                            :label="
                                $t('erp.b2c.city', {
                                    defaultValue: '城市',
                                })
                            "
                            style="width: 400px"
                            prop="city"
                            :rules="required"
                        >
                            <Input v-model="formData.city"></Input>
                        </FormItem>
                    </Col>
                </Col>
            </Form>
        </div>
        <!-- 产品信息 -->
        <div class="bg-fff shadow padding-bottom-20 margin-top-20">
            <header class="detail-title font-bold">
                {{
                    $t("erp.b2c.product_information", {
                        defaultValue: "产品信息",
                    })
                }}
            </header>
            <Form
                :label-width="120"
                :model="formData"
                class="margin-15 clearfix"
            >
                <Col span="24">
                    <FormItem
                        label="ERPSKU"
                        class="pull-left"
                        style="width: 360px"
                        prop="city"
                        :rules="required"
                    >
                        <Input
                            v-model.trim="formData.erpSku"
                            readonly
                            :placeholder="
                                $t('boss.purchase.please_select', {
                                    defaultValue: '请选择',
                                })
                            "
                        ></Input>
                    </FormItem>
                    <div class="pull-left margin-left-10">
                        <Button slot="append" @click="showInvatryBox">{{
                            $t("erp.b2c.inventory_query", {
                                defaultValue: "库存查询",
                            })
                        }}</Button>
                    </div>
                </Col>
            </Form>
            <Table
                class="margin-10"
                :columns="columns"
                :data="formList"
                size="small"
                ref="table"
                border
                stripe
            ></Table>
        </div>
        <!-- 仓库物流信息 -->
        <div class="bg-fff shadow padding-bottom-20 margin-top-20">
            <header class="detail-title font-bold">
                {{
                    $t("erp.b2c.warehouse_logistics_information", {
                        defaultValue: "仓库物流信息",
                    })
                }}
            </header>
            <Form
                :label-width="120"
                :model="formNews"
                ref="formNews"
                class="margin-15 clearfix"
            >
                <Col span="24">
                    <Col span="12">
                        <FormItem
                            :label="
                                $t('erp.b2c.delivery_warehouse', {
                                    defaultValue: '发货仓库',
                                })
                            "
                            style="width: 400px"
                            prop="orgWarehouseId"
                            :rules="required"
                        >
                            <Select
                                v-model="formNews.orgWarehouseId"
                                filterable
                                clearable
                                @on-change="getShipping()"
                            >
                                <Option value="0">System Auto</Option>
                                <Option
                                    v-for="item in getNewWarehouseCodeList"
                                    :value="item.value"
                                    :key="item.value"
                                    >{{ item.label }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem
                            :label="
                                $t('erp.b2c.shipping_method', {
                                    defaultValue: '发货方式',
                                })
                            "
                            style="width: 400px"
                            prop="shippingMethodCode"
                            :rules="required"
                        >
                            <Select
                                v-model="formNews.shippingMethodCode"
                                filterable
                                clearable
                                ref="refshipping"
                                :loading="loading1"
                            >
                                <Option value="AUTO">System Auto</Option>
                                <Option
                                    v-for="item in shippingList"
                                    :value="item.carrierServiceCode"
                                    :key="item.id"
                                    >{{ item.carrierServiceCode }}</Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Col>
            </Form>
        </div>
        <!-- 备注信息 -->
        <div class="bg-fff shadow padding-bottom-20 margin-top-20">
            <header class="detail-title font-bold">
                {{
                    $t("erp.b2c.remarks_information", {
                        defaultValue: "备注信息",
                    })
                }}
            </header>
            <Form :label-width="120" ref="form3" class="margin-15 clearfix">
                <Col span="24">
                    <FormItem
                        :label="
                            $t('boss.purchase.notes', {
                                defaultValue: '备注',
                            })
                        "
                    >
                        <Input
                            :rows="4"
                            type="textarea"
                            v-model="formData.remark"
                        ></Input>
                    </FormItem>
                </Col>
            </Form>
        </div>
        <!-- 提交取消 -->
        <div class="bg-fff text-right padding-20">
            <Button
                type="primary"
                class="width-10per margin-right-10"
                @click="submit"
                >{{
                    $t("boss.purchase.submit", {
                        defaultValue: "提交",
                    })
                }}</Button
            >
            <Button class="width-10per" @click="cancel">{{
                $t("boss.purchase.cancel", {
                    defaultValue: "取消",
                })
            }}</Button>
        </div>
        <!-- 查询库存 -->
        <Modal
            width="800"
            :title="
                $t('boss.purchase.query_inventory', {
                    defaultValue: '查询库存',
                })
            "
            @on-cancel="showSearchinvatry"
            @on-ok="setOutGroupRule"
            v-model="showInvatry"
        >
            <compSearchinventory
                ref="vsdata"
                :virtalertsearch="virtalertsearch"
                :searcherpsku="formData.erpSku"
                @on-reset="resetSKU"
            />
        </Modal>
        <!-- 查询父订单号 -->
        <Modal
            width="1000"
            :title="
                $t('boss.purchase.query_order', {
                    defaultValue: '查询订单',
                })
            "
            @on-cancel="showSearchOrder"
            @on-ok="setOutOrder"
            v-model="showOrder"
        >
            <compSearchorder
                ref="vsorder"
                :searcherporderid="formData.orderId"
                :virtalertsearch="virtalertorder"
            />
        </Modal>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>
<script>
import { mapState } from "vuex";
import {
    HttpqueryB2COrder,
    HttpsaveAdditional,
    HttpFindWarehouseCarriers,
} from "@/service/boss/b2corder";
import { HttpVsSkuList } from "@/service/boss/allot";
import compSearchinventory from "./searchinventory";
import compSearchorder from "./searchorder";
import { HttpGetStates } from "@/service/boss/b2corder";
import { HttpGetContry } from "@/service/boss/dictionary";
export default {
    components: {
        compSearchinventory,
        compSearchorder,
    },
    data() {
        return {
            id: this.$route.query.id,
            // issuper: this.$route.query.issuper == 1,
            // nodeid:this.$route.query.nodeid,
            required: [
                {
                    required: true,
                    message: this.$t("fbb.bill.fill_in", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                    trigger: "blur",
                },
            ],
            required1: [
                {
                    required: true,
                    message: this.$t("fbb.bill.fill_in", {
                        defaultValue: "该信息不能为空,请填写",
                    }),
                },
            ],

            formData: {
                orderId: "",

                shippingName: "",
                countryCode: "",
                addressline: "",
                addressline2: "",
                addressline3: "",
                state: "",
                postalCode: "",
                phone: "",
                city: "",

                erpSku: "",

                remark: "",
                comeback: "allow",
            },
            formNews: {
                orgWarehouseId: "0",
                shippingMethodCode: "AUTO",
            },
            warehouseId: 0,
            shippingList: [],
            baseinfo: {},
            showInvatry: false,
            virtalertsearch: false,
            virtalertorder: false,
            datalist: [],
            countries: [],
            states: [],
            showOrder: false,
            loading: false,
            loading1: false,
        };
    },
    created() {
        if (this.$route.query.id) {
            this.getDetail(this.$route.query.id);
        }
    },
    updated() {
        this.yanzhen();
    },
    computed: {
        ...mapGetters("diction", ["getNewWarehouseCodeList"]),
        formList() {
            return this.datalist || [];
        },
        columns() {
            const _this = this;
            return [
                {
                    title: "ERPSKU",
                    key: "erpSku",
                    render(h, { row }) {
                        return <div>{row.erpSku}</div>;
                    },
                },
                {
                    title: this.$t("erp.b2c.available_stock", {
                        defaultValue: "可用库存",
                    }),
                    key: "inventoryAvailable",
                    render(h, { row }) {
                        return <div>{row.inventoryAvailable}</div>;
                    },
                },
                {
                    title: this.$t("erp.b2c.number", {
                        defaultValue: "数量",
                    }),
                    render(h, { row, index }) {
                        return h("InputNumber", {
                            props: {
                                size: "small",
                                min: 1,
                                value: row.quantity,
                            },
                            on: {
                                input: (event) => {
                                    row.quantity = event;
                                    _this.datalist[index] = row;
                                },
                            },
                        });
                    },
                },
                {
                    title: this.$t("erp.b2c.product_name", {
                        defaultValue: "产品名称",
                    }),
                    render(h, { row }) {
                        return <div>{row.title}</div>;
                    },
                },
                {
                    title: this.$t("boss.purchase.operate", {
                        defaultValue: "操作",
                    }),
                    render(h, { row, index }) {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "error",
                                        size: "small",
                                    },
                                    on: {
                                        click: () => {
                                            _this.remove(index);
                                        },
                                    },
                                },
                                this.$t("boss.purchase.delete", {
                                    defaultValue: "删除",
                                })
                            ),
                        ]);
                    },
                },
            ];
        },
    },
    methods: {
        getDetail(orderid) {
            // console.log(this.$route)/
            this.loading = true;
            return HttpqueryB2COrder({
                orderId: orderid,
                // node:this.nodeid,
            }).then(
                (res) => {
                    this.loading = false;
                    this.handleRequest(res.data);
                    this.getCountry();
                },
                (err) => {
                    this.loading = false;
                    this.errorMessage(err.message);
                }
            );
        },
        handleRequest(data) {
            let { orderId } = data.baseInfo;
            let {
                shippingName,
                countryCode,
                addressline,
                addressline2,
                addressline3,
                state,
                postalCode,
                phone,
                city,
            } = data.receive;
            // setTimeout(() => {
            this.formData = {
                orderId,
                shippingName,
                countryCode,
                addressline,
                addressline2,
                addressline3,
                state,
                postalCode,
                phone,
                city,
            };
            this.formData.comeback = "allow";
            this.oneCountry(this.formData.countryCode);
            // }, 50);
            // console.log(this.formData)
        },
        yanzhen() {
            let valid = this.$refs["form2"].validate();
            if (!valid) return;
        },
        oneCountry(code, type) {
            HttpGetContry({
                "search[EQ_depth]": 2,
                "search[EQ_code]": code,
            }).then(
                (res) => {
                    let onecode = res.data[0];
                    this.getStates(onecode.id, type);
                },
                (err) => {}
            );
        },
        getCountry() {
            HttpGetContry({
                "search[EQ_depth]": 2,
            }).then(
                (res) => {
                    this.countries = res.data;
                },
                (err) => {}
            );
        },
        getStates(code, type) {
            if (type == "edit") {
                this.$refs.selectstate.clearSingleSelect();
            }
            this.loading = true;
            HttpGetStates({
                "search[EQ_depth]": 4,
                "search[EQ_parentId]": code,
            })
                .then(
                    (res) => {
                        this.states = res.data;
                    },
                    (err) => {}
                )
                .finally((res) => {
                    this.loading = false;
                });
        },

        showFuorderBox() {
            this.showOrder = true;
            this.virtalertorder = true;
        },
        showSearchOrder() {
            this.showOrder = false;
            this.virtalertorder = false;
        },
        setOutOrder() {
            const rows = this.$refs.vsorder.getRowData();
            this.getDetail(rows.id);
        },
        // reset
        resetSKU() {
            this.formData.erpSku = "";
        },
        showInvatryBox() {
            this.showInvatry = true;
            this.virtalertsearch = true;
        },
        showSearchinvatry() {
            this.showInvatry = false;
            this.virtalertsearch = false;
            this.formData.erpSku = "";
        },
        setOutGroupRule() {
            const rows = this.$refs.vsdata.getRowData();
            this.datalist = rows;
        },

        // 数组去重
        arrayUnique(arr, name) {
            var hash = {};
            return arr.reduce((item, next) => {
                hash[next[name]]
                    ? ""
                    : (hash[next[name]] = true && item.push(next));
                return item;
            }, []);
        },
        getShipping() {
            // console.log(123213)
            // let _this = this;
            this.loading = true;
            this.loading1 = true;
            // this.formData.shippingMethodCode = ''
            this.$refs.refshipping.clearSingleSelect();
            this.getNewWarehouseCodeList.map((item) => {
                if (this.formNews.orgWarehouseId == item.value) {
                    // console.log(2323232)
                    // console.log(item)
                    // console.log(this.formNews.orgWarehouseId)
                    this.warehouseId = item.attach.id;
                } else if (this.formNews.orgWarehouseId == "0") {
                    this.warehouseId = 0;
                }
            });
            HttpFindWarehouseCarriers({
                warehouseCode: this.formNews.orgWarehouseId,
                orderType: 200,
            })
                .then(
                    (res) => {
                        let aaa = [
                            { carrierServiceCode: "WLC" },
                            { carrierServiceCode: "YRC" },
                            { carrierServiceCode: "Australia Post" },
                            { carrierServiceCode: "Other" },
                        ];
                        this.shippingList = res.data;
                        this.shippingList = this.shippingList.concat(aaa);
                        this.shippingList = this.arrayUnique(
                            this.shippingList,
                            "carrierServiceCode"
                        );
                        // this.shippingList = res.data
                    },
                    (err) => {
                        this.errorMessage(err.message);
                    }
                )
                .finally((result) => {
                    this.loading = false;
                    this.loading1 = false;
                });
        },
        remove(index) {
            this.datalist.splice(index, 1);
        },
        async submit() {
            let valid = await this.$refs["form2"].validate();
            if (!valid) {
                this.$Message.error(
                    this.$t("boss.purchase.value_cannot_empty", {
                        defaultValue: "数值不能为空",
                    })
                );
                return;
            }
            if (this.datalist.length == 0) {
                this.$Message.error(
                    this.$t("boss.purchase.product_information_cannot_empty", {
                        defaultValue: "产品信息不能为空",
                    })
                );
            } else {
                // console.log(this.$refs.table)
                let data = {
                    remark: this.formData.remark,
                    b2cOrderRelationItem: {
                        parentId: this.formData.orderId,
                        isAllowTracking: this.formData.comeback,
                    },
                    receive: {
                        shippingName: this.formData.shippingName,
                        addressline: this.formData.addressline,
                        addressline2: this.formData.addressline2,
                        addressline3: this.formData.addressline3,
                        countryCode: this.formData.countryCode,
                        state: this.formData.state,
                        city: this.formData.city,
                        postalCode: this.formData.postalCode,
                        phone: this.formData.phone,
                    },
                    products: this.datalist,
                    logistics: {
                        orgWarehouseId: this.warehouseId,
                        shippingMethodCode: this.formNews.shippingMethodCode,
                    },
                };
                // console.log(data)
                HttpsaveAdditional({
                    ...data,
                }).then(
                    (res) => {
                        this.$Message.success(res.message);
                        this.$router.push({
                            name: "giftb2cOrder",
                        });
                    },
                    (err) => {
                        this.errorMessage(err.message);
                    }
                );
            }
        },
        cancel() {
            this.$router.push({
                name: "b2cOrder",
            });
        },
    },
};
</script>
